/* eslint-disable prettier/prettier */
import React, {createContext} from 'react'
import {App, notification, ModalFuncProps} from 'antd';
type ArgsProps = Parameters<typeof notification.open>[0];

export const PopupContext = createContext({});

export const PopupProvider = ({ children }: any) => {
    const { notification: AntdNotification, message: AntdMessage, modal: AntdModal } = App.useApp();

    const message: any = {
        info: (text: string) => {
            AntdMessage.info(text);
        },
        success: (text: string) => {
            AntdMessage.success(text);
        },
        warning: (text: string) => {
            AntdMessage.warning(text);
        },
        error: (text: string) => {
            AntdMessage.error(text);
        }
    };
    const notification: any = {
        success: (props: ArgsProps) => {
            AntdNotification.success({ showProgress: true, pauseOnHover: true, ...props });
        },
        info: (props: ArgsProps) => {
            AntdNotification.info({ showProgress: true, pauseOnHover: true, ...props });
        },
        warning: (props: ArgsProps) => {
            AntdNotification.warning({ showProgress: true, pauseOnHover: true, ...props  });
        },
        error: (props: ArgsProps) => {
            AntdNotification.error({ showProgress: true, pauseOnHover: true, ...props });
        }
    }
    const modal: any = {
        confirm: (props: ModalFuncProps) => {
            AntdModal.confirm({
                centered: true,
                className: 'lib-modal-static lib-modal-static-confirm',
                okButtonProps: { size: 'large', type: 'primary' },
                cancelButtonProps: { size: 'large', ghost: true },
                ...props,
            });
        },
        warning: (props: ModalFuncProps) => {
            AntdModal.warning({ centered: true, className: 'lib-modal-static', ...props });
        },
        info: (props: ModalFuncProps) => {
            AntdModal.info({ centered: true, className: 'lib-modal-static', ...props });
        },
        error: (props: ModalFuncProps) => {
            AntdModal.error({ centered: true, className: 'lib-modal-static', ...props });
        },
    }

    return (
        <PopupContext.Provider value={{ message, notification, modal }}>
            {children}
        </PopupContext.Provider>
    );
};
